interface LowVisionProps {
  fill?: string;
  stroke?: string;
}

export default function LowVision({
  fill = "#626060",
  stroke = "#626060",
}: LowVisionProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.34056L7.28 8L24 25.6489L22.73 27L19.65 23.7489C18.5 24.15 17.28 24.3611 16 24.3611C11 24.3611 6.73 21.0783 5 16.4444C5.69 14.5867 6.79 12.9506 8.19 11.6522L6 9.34056ZM16 13.2778C16.7956 13.2778 17.5587 13.6114 18.1213 14.2053C18.6839 14.7991 19 15.6046 19 16.4444C19.0005 16.8039 18.943 17.1609 18.83 17.5L15 13.4572C15.3213 13.3379 15.6594 13.2772 16 13.2778ZM16 8.52778C21 8.52778 25.27 11.8106 27 16.4444C26.1834 18.6325 24.7966 20.5319 23 21.9228L21.58 20.4133C22.9629 19.4036 24.0783 18.0374 24.82 16.4444C24.0117 14.7026 22.7565 13.2352 21.1974 12.2089C19.6382 11.1826 17.8375 10.6386 16 10.6389C14.91 10.6389 13.84 10.8289 12.84 11.1667L11.3 9.55167C12.74 8.89722 14.33 8.52778 16 8.52778ZM7.18 16.4444C7.98835 18.1863 9.24345 19.6537 10.8026 20.68C12.3618 21.7063 14.1625 22.2503 16 22.25C16.69 22.25 17.37 22.1761 18 22.0283L15.72 19.6111L14.2718 18.0921L13 16.74L9.6 13.1406C8.61 14.0378 7.78 15.1567 7.18 16.4444Z"
        fill={fill}
      />
      <path
        d="M16.7934 22.7582L8.50006 14M14.2345 22.5516L7.5 15.5"
        stroke={stroke}
      />
    </svg>
  );
}
